import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-push-preview',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="device-frame" [ngClass]="platform">
      <div class="status-bar">
        <span class="time">12:30</span>
        <span class="icons">📶 🔋</span>
      </div>

      <div class="notification">
        <img *ngIf="logo" [src]="logo" alt="logo" class="logo" />
        <div class="content">
          <h4>{{ truncatedTitle || 'Título do aviso' }}</h4>
          <p [innerHTML]="sanitizedMessage"></p>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        max-width: 300px;
        margin: 1rem auto;
      }
      .device-frame {
        position: relative;
        background: gray;
        border-radius: 26px;
        padding: 48px 14px 14px;
        color: #fff;
      }
      .status-bar {
        position: absolute;
        top: 12px;
        left: 0;
        right: 0;
        text-align: center;
        font-size: 0.75rem;
      }
      .icons {
        position: absolute;
        right: 14px;
      }
      .notification {
        display: flex;
        background: lightgray;
        border-radius: 8px;
        padding: 12px;
      }
      .notification.ios {
        background: #1c1c1e;
      }
      .logo {
        width: 32px;
        height: 32px;
        border-radius: 8px;
        margin-right: 8px;
        object-fit: cover;
      }
      .content h4 {
        margin: 0 0 4px;
        font-size: 0.875rem;
      }
      .content p {
        margin: 0;
        font-size: 0.8125rem;
        line-height: 1.2;
        color: black;
      }
    `
  ]
})
export class PushPreviewComponent {
  @Input() title = '';
  @Input() message = '';
  @Input() logo = '';
  @Input() platform: 'android' | 'ios' = 'android';

  constructor(private sanitizer: DomSanitizer) {}

  // Limites de caracteres
  readonly TITLE_LIMIT = 28;
  readonly MESSAGE_LIMIT = 100;

  get truncatedTitle(): string {
    return this.truncate(this.title, this.TITLE_LIMIT);
  }

  get truncatedMessage(): string {
    return this.truncate(this.message, this.MESSAGE_LIMIT);
  }

  get sanitizedMessage(): SafeHtml {
    const fallback = 'Corpo do aviso';
    const content = this.truncatedMessage || fallback;
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }

  private truncate(text: string, limit: number): string {
    if (!text) return '';
    return text.length > limit ? text.slice(0, limit).trim() + '…' : text;
  }
}
